import ProjectEditorList from './ProjectEditorList.vue'
import ProjectList from './ProjectList.vue'
import { getAccessContext } from '@/services/accessContext'
import { canManageProjectAdministration } from '@/utils/accessPolicy'
import { safeErrorDigest } from '../utils/safeResponseMessage'

/**
 * プロジェクト一覧をPermissionに応じて切り替える。
 *
 * PROJECT_EDITの一般社員には登録・更新用一覧だけを表示し、従来の
 * PROJECT_MANAGE保持者には削除・所属変更を含む既存一覧をそのまま表示する。
 */
export default {
  name: 'ProjectListAccessPage',
  data () {
    return {
      accessContext: null,
      loading: true,
      errorMessage: ''
    }
  },
  created () {
    this.loadAccessContext()
  },
  methods: {
    async loadAccessContext () {
      this.loading = true
      this.errorMessage = ''
      try {
        this.accessContext = await getAccessContext()
      } catch (error) {
        this.errorMessage = 'プロジェクト画面の権限情報を取得できませんでした。'
        console.error('プロジェクト一覧権限取得失敗:', safeErrorDigest(error))
      } finally {
        this.loading = false
      }
    }
  },
  render (createElement) {
    if (this.loading) {
      return createElement('div', { class: 'd-flex align-items-center py-4' }, [
        createElement('span', {
          class: 'spinner-border spinner-border-sm mr-2',
          attrs: { role: 'status', 'aria-hidden': 'true' }
        }),
        createElement('span', 'プロジェクト情報を読み込んでいます。')
      ])
    }

    if (this.errorMessage || !this.accessContext) {
      return createElement('div', {
        class: 'alert alert-danger',
        attrs: { role: 'alert' }
      }, [this.errorMessage || 'プロジェクト画面を表示できません。'])
    }

    return createElement(
      canManageProjectAdministration(this.accessContext)
        ? ProjectList
        : ProjectEditorList
    )
  }
}
